import React from 'react'

export const DishDetailHeading: React.FC<{heading?: string}> = ({heading=""}) => {
  return (
    <h3 className="text-[16px] leading-[18px] font-semibold text-primary">
      {heading}
    </h3>
  )
}
